import * as Yup from "yup";
export const editFolderNameInitialValues = (name) => {
    return {
        name,
    };
};
export const editFolderNameValidationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
});
